var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'genres-list',
        _vm.horScroll && 'genres-list--hor-scroll',
        _vm.horScrollMobile && 'genres-list--hor-scroll-mobile',
        _vm.padded && 'genres-list--padded',
    ]},_vm._l((_vm.genres),function(genre,index){return _c('div',{key:`genre${index}`,staticClass:"genres-list__item"},[_c('div',{staticClass:"genres-list__genre",on:{"click":function($event){_vm.$router.push({ name: 'genre', params: { id: _vm.genreLink(genre) } })}}},[_vm._v(" "+_vm._s(genre)+" ")]),(_vm.hasTypeTitle)?_c('div',{staticClass:"genres-list__type-title"},[_vm._v("Genre")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }